import type {ReactNode} from 'react'

interface PageHeaderProps {
    /** Small mono eyebrow label shown above the title — e.g. a standards reference. */
    eyebrow: string
    /** Main page title. */
    title: string
    /** Optional paragraph shown below the title. */
    subtitle?: ReactNode
}

export function PageHeader({eyebrow, title, subtitle}: PageHeaderProps) {
    return (
        <div>
            <p className='font-mono text-xs tracking-[0.3em] uppercase text-foreground/40 mb-2'>
                {eyebrow}
            </p>
            <h1 className='text-4xl font-bold tracking-tight text-foreground'>{title}</h1>
            {subtitle && <p className='mt-3 text-sm text-foreground/60 max-w-2xl'>{subtitle}</p>}
        </div>
    )
}
